<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="exports()"><i class="el-icon-download"></i>导出</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    v-if="nameEnable"
                    min-width="120"
                    prop="name"
                    label="姓名" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    v-if="phoneEnable"
                    prop="phone"
                    label="手机号">
                </el-table-column>
                <el-table-column
                    min-width="120"
                    v-if="sexEnable"
                    prop="sex"
                    label="性别">
                </el-table-column>
                <el-table-column
                    min-width="120"
                    v-if="ageEnable"
                    prop="age"
                    label="年龄">
                </el-table-column>
                <el-table-column
                    min-width="120"
                     v-if="schoolEnable"
                    prop="school"
                    label="学校">
                </el-table-column>
                <el-table-column
                    min-width="120"
                     v-if="gradeEnable"
                    prop="grade"
                    label="年级">
                </el-table-column>
                <el-table-column
                    min-width="120"
                     v-if="clazzEnable"
                    prop="clazz"
                    label="班级">
                </el-table-column>
                <el-table-column
                    min-width="120"
                     v-if="remarkEnable"
                    prop="remarkFormHtml"
                    label="备注">
                </el-table-column>
                 <el-table-column
                    min-width="120"
                    prop="createTime"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="200"
                >
                    <template slot-scope="scope">
                        <div class="fx fx-m_between fx-center">
                            <el-popconfirm @onConfirm="remove(scope.row)"
                                           title="确认移除该信息吗？"
                            >
                                <div slot="reference" class="fx fx-m_between fx-center">
                                    <el-button type="danger" icon="el-icon-minus" circle size="mini" style="padding: 2px"></el-button>
                                     <span class="remove_btn ">移除</span>
                                </div>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>
    .remove_btn {
        padding-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>

<script>

    import {mapMutations} from 'vuex';

    export default {
        components: {
        },
        props: [
            "attr"
        ],
        data() {
            return {
                editItem: {},
                showEdit: false,
                form: {
                    ...this.attr,
                    keywords: "",
                    enable:true,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                nameEnable:false,
                phoneEnable:false,
                sexEnable:false,
                ageEnable:false,
                schoolEnable:false,
                gradeEnable:false,
                clazzEnable:false,
                remarkEnable:false,
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations(["openTab"]),
            edit(item) {
                item.datesVelue = [];
                this.editItem = {...item};
                this.showEdit = true;
            },
            loadData() {
                this.$ajaxPost("/activityUserInfo/list", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            exports() {
                window.open("/activityUserInfo/exportUserInfos/"+this.form.activityId+"?token=" + localStorage.getItem("token"));
            },
            loadDataEnable(){
                this.$ajaxPost("/activityBuiltInForm/list", {
                    form: this.form,
                }, (data) => {
                    let tableDataEnable = data.result;
                    let nameData = tableDataEnable.filter(res =>  res.type == 1)[0];
                    this.nameEnable = nameData == undefined ? false : nameData.enable ;
                    let sexData = tableDataEnable.filter(res =>  res.type == 2)[0];
                    this.sexEnable = sexData == undefined ? false : sexData.enable;
                    let phoneData = tableDataEnable.filter(res =>  res.type == 8)[0];
                    this.phoneEnable = phoneData ==  undefined ? false : phoneData.enable;
                    let ageData = tableDataEnable.filter(res =>  res.type == 3)[0];
                    this.ageEnable = ageData == undefined ? false : ageData.enable ;
                    let schoolData = tableDataEnable.filter(res =>  res.type == 4)[0];
                    this.schoolEnable = schoolData == undefined ? false : schoolData.enable;
                    let gradeData = tableDataEnable.filter(res =>  res.type == 5)[0];
                    this.gradeEnable = gradeData ==  undefined ? false : gradeData.enable;
                    let clazzData = tableDataEnable.filter(res =>  res.type == 6)[0];
                    this.clazzEnable = clazzData == undefined ? false : clazzData.enable ;
                    let remarkData = tableDataEnable.filter(res =>  res.type == 7)[0];
                    this.remarkEnable = remarkData == undefined ? false : remarkData.enable;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            remove(item) {
                this.$ajaxGet("/activityUserInfo/del/" + item.id, data => {
                    this.$showSuccess("保存成功");
                    this.loadData();
                })
            },
        },
        created() {
            this.loadDataEnable();
            this.loadData();
        }
    }
</script>
